import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout-private/finance/")({
	component: () => <div>Hello /_layout-private/finance/!</div>,
});
